import api from './api.service';

function getOptions() {
  return api.get('/support-tickets/options');
}

function index(params) {
  return api.get('/support-tickets', params);
}

function show(id) {
  return api.get(`/support-tickets/${id}`);
}

function store(params) {
  return api.post('/support-tickets', params);
}

function updateStatus(id, params) {
  return api.put(`/support-tickets/${id}/status`, params);
}

function downloadAttachment(fileId) {
  return api.getFile(`/support-tickets/attachments/${fileId}/download`);
}

export const supportService = {
  getOptions,
  index,
  show,
  store,
  updateStatus,
  downloadAttachment,
};
